import { PRODUCT_URI_ORIGIN } from '../common/constants';
import { postGraphQLQuery } from '../common/postGraphQLQuery';
import { unifiedProductQuery } from './queries/unifiedProductQuery';
import type { UnifiedProduct } from './types/UnifiedProduct';

export interface FetchUnifiedProductArgs {
  /** The UPS GraphQL endpoint, supplied by the consuming app's own validated config. */
  endpoint: string;
  /** Defaults to the live origin. See PRODUCT_URI_ORIGIN for why that is not environment specific. */
  origin?: string;
  /** Site relative path, e.g. `/a-partner/product/a-product`. */
  productPath: string;
  /** Required rather than defaulted: how long a caller can afford to wait is the caller's business. */
  timeout: number;
}

/**
 * Resolves with null when UPS holds no product at that URI, and throws on any failure.
 */
export const fetchUnifiedProduct = async ({
  endpoint,
  origin = PRODUCT_URI_ORIGIN,
  productPath,
  timeout,
}: FetchUnifiedProductArgs): Promise<UnifiedProduct | null> => {
  const { product } = await postGraphQLQuery<{ product: UnifiedProduct | null }>({
    endpoint,
    query: unifiedProductQuery,
    timeout,
    variables: { productUri: `${origin}${productPath}` },
  });

  return product;
};
